import { render } from "./CompetitionsMain.vue?vue&type=template&id=28d8bc86&scoped=true"
import script from "./CompetitionsMain.vue?vue&type=script&lang=js"
export * from "./CompetitionsMain.vue?vue&type=script&lang=js"

import "./CompetitionsMain.vue?vue&type=style&index=0&id=28d8bc86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d8bc86"]])

export default __exports__